import { httpProxy } from "../api";
import { ContactFormData } from '../../stores/useContactStore';

async function sendMessage(data: ContactFormData) {
    const response = await httpProxy.post("/contact/message",  JSON.stringify(data));
    return response;
}

export default {
  sendMessage
};
